module.exports = __webpack_public_path__ + "img/ckfbd.4466aa63.png";